import { RouteLocationNormalizedLoaded } from "vue-router";
import { FORM_MODE, FormMode } from "./types";

export function FormRouteName(routeName: string, formMode: FormMode) {
    return `${routeName}${formMode}`;
}

function getParentRoute(route: RouteLocationNormalizedLoaded) {
    return route.matched.length - 2 >= 0 ? route.matched[route.matched.length - 2] : null;
}

export function getResolvedRouteName(targetRouteName: string, currentRoute: RouteLocationNormalizedLoaded) {
    const parentRoute = getParentRoute(currentRoute);
    return FormRouteName(targetRouteName, (parentRoute?.name as FORM_MODE) ?? FORM_MODE.CREATE);
}
